import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PumpReturnForm from "@preferredMedical/Widgets/PumpReturnForm/PumpReturnForm";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    emailRecipients = "emailRecipients",
    productNames = "productNames"
}

const mapStateToProps = (state: ApplicationState) => ({
    session: state.context.session,
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const cssWrapper = {
    css: css`
            margin-top: 30px;
            text-align: center;
        `,
};

const PumpReturnWidget: React.FC<Props> = ({ session, fields }) => {

    return (
        <StyledWrapper {...cssWrapper}>
            <PumpReturnForm
                emailRecipients={fields.emailRecipients}
                productNames={fields.productNames}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PumpReturnWidget),
    definition: {
        displayName: "Pump Return",
        group: "Header",
        fieldDefinitions: [
            {
                name: fields.emailRecipients,
                displayName: "Email recipients (one on each row)",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "",
                isRequired: true
            },
            {
                name: fields.productNames,
                displayName: "Product Names (one on each row)",
                editorTemplate: "MultilineTextField",
                fieldType: "General",
                defaultValue: "",
                isRequired: true
            }
        ]
    },
};

export default widgetModule;